import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { Author } from 'projects/lms-api/src/public-api';
import { LMSDataService } from 'lms-api';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-course-author-seo-list',
  templateUrl: './course-author-seo-list.component.html',
  styleUrls: ['./course-author-seo-list.component.scss']
})
export class CourseAuthorSeoListComponent implements OnInit, OnChanges {
  @Input() public authors: object[];
  public authors$: Observable<Author>[];
  
  constructor(private lmsDataService: LMSDataService) { }

  ngOnInit(): void {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.authors.currentValue) {
      this.authors$ = [];
      for(let author of changes.authors.currentValue) {
        this.authors$.push(this.lmsDataService.GetAuthor(author.id));
      }
    }
  }

}
